const validation = {
    warning: 'Warning!',
    error: 'Please fill all the required fields with validations!',
    delete: 'Are you sure to delete?',
    deleteStatus: 'Do you really want to delete this status entry?',
    graduateAlert: 'Record cannot be modified!',
    invalidProgram: 'Invalid Program!',
    invalidExam: 'Graduation requirements not met.  Please check the graduation requirements tab.',
    graduateCheck: 'Are you sure you want to mark this student as graduated? The student record will be moved to the alumni section. This step cannot be undone.',
    required: 'Field is required',
    requiredGreater: 'Field is required and must be greater than 0.5',
    maxDigits: 'Max {num} Digits allowed',
    maxCharacters: 'Max {num} Characters allowed',
    maxLength: 'Max {num} Characters allowed',
    minLength: 'Min {num} Characters allowed',
    containsUppercase: 'Field needs to contain at least one uppercase letter',
    containsLowercase:'Field needs to contain at least one lowercase letter',
    containsNumber:'Field needs to contain at least one number',
    containsSpecial: 'Field needs to contain at least one Special character',
    sameAsPassword: 'Confirm password is not same',
    validEmail: 'Must be valid email address',
    numbersAllowed: 'Only numbers allowed.',
    decimalAllowed: 'Only decimal numbers allowed',
    between: 'Must be between {num1} and {num2}.',
    selectProgram: 'Please select a program!',
    subjectField: 'Please fill subject field',
    messageField: 'Please fill message field',
    selectStudent: 'Please select atleast one student!',
    passwordNotMatch: 'Password confirmation does not matched!',
    requiredDocuments: 'Please upload/fill all the required documents/fields to continue.',
    selectContactList: 'Please select contact list first',
    usernameAndPassword: 'Please enter username and password!',
    invalidStatus: 'Please select status to continue',
    integerAllowed: 'Only interger value allowed.',
    cannotAllowed: 'Cannot allowed to change student!',
    noStudents: 'No student selected, please select at least one student or change program if none available.',
    noneSelected: 'Please select a record to perform this action.',
    subnet: 'Should be valid IP or Subnet Mask in CIDR format. (10.1.1.0/24)',
    greater: 'The "To" date must be greater or equal to "From" date.',
    invalidDate: 'The provided date wildcard is not valid. (Example: 01.01.*)',
    invalidPin: 'Please enter valid OTP to continue.',
    exists: 'The record with same details already exists.',
    rejectionFoundFor: 'Rejection found for the student(s): {ids}',
    deleteFile: 'Are you sure you want to delete this file?',
    mandatoryFieldsError:'Please complete and check the following mandatory field(s): {errors}',
    lowercase:'Lower case',
    uppercase:'Upper case',
    numbers:'Numbers',
    symbols:'Symbols',
    atleast8characters:'8 Characters',
    onlyNumbersAllowedInDiscount: 'Only numbers are allowed in Global Scholarship Reduction field.', 
    deleteSentInvoice:'This invoice has already been sent out. Are you sure you want to delete it?',
    deleteSentPaymentSummary:'This payment summary has already been sent out. Are you sure you want to delete it?',
    deletePaidInvoice:'This invoice has already been paid. Are you sure you want to delete it?',
    cantDeleteInvoice: 'Sorry, you do not have permission to delete invoices.',
    cantDeleteReductionTypePermission:'Sorry, you do not have permission to delete reduction types.',
    cantEditReductionTypePermission:'Sorry, you do not have permission to edit reduction types.',
    cantCreateReductionTypePermission:'Sorry, you do not have permission to add reduction types.',
    cantDeleteReductionTypeInUse: 'Sorry, you cant delete a reduction type that is in use.',
    invalidGlobalDiscount:'Global Discount is invalid'
};

export default validation;